<template>
  <div class="container">

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster-clock' }">打卡</el-breadcrumb-item>
        <el-breadcrumb-item >设置外出打卡</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <div class="cont">
      <el-form ref="form" :model="formData"   label-width="130px" :rules="rules">

        <el-form-item label="考勤名称" prop="title" >  
          <el-input v-model="formData.title" placeholder="考勤名称"></el-input>
       </el-form-item>

       <el-form-item label="项目选择" prop="project_id">
          <el-select
              v-model="formData.project_id" placeholder="全部"
                clearable
                filterable
                @change="selectProject"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="职位选择" prop="job_id">
          <el-select
              v-model="formData.job_id" placeholder="全部"
                clearable
                filterable
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>


       <el-form-item label="拍照打卡" prop="img_type">
          <el-radio-group v-model="formData.img_type">
            <el-radio  :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="back">取消</el-button>
        </el-form-item>
     </el-form>
    </div>
    
  </div>
</template>

<script>
import { addClockOut,updateOutClock,clockSetInfo} from "@/api/director/clock/index.js";


import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";

export default {
    name: "Director-Work-CLock",
    data() {
      return {
        id:"",

        rules: {

          
          title: [
                {required: true, message: '请输入考勤名称', trigger: 'blur'}
           ],
          job_id: [
                {required: true, message: '请选择职位', trigger: 'change'}
            ],
            project_id: [
                {required: true, message: '请选择项目', trigger: 'change'}
            ],
            type: [
                {required: true, message: '请选择打卡类型', trigger: 'change'}
            ],
            img_type: [
                {required: true, message: '请设置是否拍照打卡', trigger: 'change'}
            ]
           
       },

        formData:{
          id:"",
          project_id:"",
          job_id:"",//职位id
          type:"3",//打卡类型，1固定上下班，2自由上下班
          title:"",//考勤名称
          img_type:1,//是否，1允许，2不允许

        },

        addressObj:{},
        projectDataList:[],
        jobDataList:[],
        addressDataList:[]

      }
    },

    mounted() {
      this.id = this.$route.query.id;
     
      if(this.id){
        this.initData();
      }
      if(this.$route.query.project_id){
        this.formData.project_id=parseInt(this.$route.query.project_id);
      }
      this.initProjectList();
      this.initJobList();
    },

    methods: {

      initData(){
        var that=this;
        clockSetInfo({id:that.id}).then((response) => {
                console.log(response);
                if(response.code==200){
                  that.formData=response.data;
                  delete that.formData.created_at;
                  delete that.formData.updated_at;
                  delete that.formData.user_app_ids;
                  
                }else{
                  this.$message({
                    message: response.msg?response.msg:"获取信息失败",
                  });
                }
              });
      },
       //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;

      });
      
    },

    selectProject(e){
      this.formData.project_id=e;
      this.formData.job_id=""
      this.initJobList();
    },
    

    //职位列表
    initJobList(){
      var that = this;
      jobList({project_id:that.formData.project_id}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },


    back(){
        this.$router.go(-1);
    },

   

    onSubmit(){

      var that=this;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            if(that.id){
              updateOutClock(that.formData).then((response) => {
                    console.log(response);
                    if(response.code==200){
                      this.$message({
                        message: "提交成功",
                        type: 'success'

                      });
                      that.$router.go(-1)
                      //that.$router.push({ name: "director-workmaster-clock" });
                    
                    }else{
                      this.$message({
                        message: response.msg?response.msg:"提交失败",
                      });
                    }
                });
            }else{
              addClockOut(that.formData).then((response) => {
                    console.log(response);
                    if(response.code==200){
                      this.$message({
                        message: "提交成功",
                        type: 'success'

                      });
                      //that.$router.push({ name: "director-workmaster-clock" });
                      that.$router.go(-1)
                    
                    }else{
                      this.$message({
                        message: response.msg?response.msg:"提交失败",
                      });
                    }
              });
            }
          } 
        });
    }
      
  }
}
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
      


    }
  }
}
</style>